/**
 * Back-to-top button: visible after scroll threshold, scrolls to top on click.
 */
class BackToTop extends HTMLElement {
  static get observedAttributes() {
    return ['threshold'];
  }

  constructor() {
    super();
    this.threshold = 400;
    this.#boundOnScroll = this.#onScroll.bind(this);
    this.#boundOnClick = this.#onClick.bind(this);
  }

  connectedCallback() {
    this.threshold = Number(this.getAttribute('threshold')) || 400;
    this.#button = this.querySelector('[ref="button"]');
    if (this.#button) this.#button.addEventListener('click', this.#boundOnClick);
    window.addEventListener('scroll', this.#boundOnScroll, { passive: true });
    this.#onScroll();
  }

  disconnectedCallback() {
    if (this.#button) this.#button.removeEventListener('click', this.#boundOnClick);
    window.removeEventListener('scroll', this.#boundOnScroll);
  }

  #button = null;
  #boundOnScroll;
  #boundOnClick;

  #onScroll() {
    const visible = window.scrollY > this.threshold;
    if (visible) {
      this.setAttribute('visible', '');
    } else {
      this.removeAttribute('visible');
    }
  }

  #onClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

customElements.define('back-to-top', BackToTop);
